import { useMemo } from 'react';
import type { ResumeData, SkillType } from '../../lib/types';

const TYPES: SkillType[] = ['programming-language', 'framework', 'platform', 'build-tool'];
const LABELS: Record<SkillType, string> = {
  'programming-language': 'Languages',
  framework: 'Frameworks',
  platform: 'Platforms',
  'build-tool': 'Build Tools',
};

export default function TechnicalSkills({ data }: { data: ResumeData }) {
  const grouped = useMemo(() => {
    const out: Record<SkillType, typeof data.technologies> = {
      'programming-language': [],
      framework: [],
      platform: [],
      'build-tool': [],
    };
    for (const t of data.technologies ?? []) {
      if (t.type in out) out[t.type].push(t);
    }
    return out;
  }, [data.technologies]);

  return (
    <section className="container-fluid">
      <h2>Technical Skills</h2>
      <div className="row">
        <div className="col-sm-12">
          <ul>
            {TYPES.map((type) => {
              const items = grouped[type];
              if (!items.length) return null;
              return (
                <li key={type}>
                  <strong>{LABELS[type]}: </strong>
                  <span>
                    {items.map((t, i) => (
                      <span key={t.name + i}>
                        {t.name}
                        {i !== items.length - 1 ? ', ' : ''}
                      </span>
                    ))}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
